export enum SpecificationMeasureUnit {
  NONE = 'NONE',
  INCHES = 'INCHES',
  MILLIMETERS = 'MILLIMETERS',
  GALLONS = 'GALLONS',
  LBS = 'LBS',
}

export const SPECIFICATION_MEASURE_UNIT_MAPPER: Readonly<Record<SpecificationMeasureUnit, string>> = Object.freeze({
  [SpecificationMeasureUnit.NONE]: '',
  [SpecificationMeasureUnit.INCHES]: 'Inches',
  [SpecificationMeasureUnit.MILLIMETERS]: 'Millimeters',
  [SpecificationMeasureUnit.GALLONS]: 'Gallons',
  [SpecificationMeasureUnit.LBS]: 'Lbs',
});

export const SPECIFICATION_MEASURE_UNIT_SHORT_MAPPER: Readonly<Record<SpecificationMeasureUnit, string>> =
  Object.freeze({
    [SpecificationMeasureUnit.NONE]: '',
    [SpecificationMeasureUnit.INCHES]: '"',
    [SpecificationMeasureUnit.MILLIMETERS]: 'mm',
    [SpecificationMeasureUnit.GALLONS]: ' gallon',
    [SpecificationMeasureUnit.LBS]: 'lbs',
  });
